import {
  Box,
  Typography,
  FormControl,
  FormLabel,
  TextField,
  Stack,
  Grid,
} from "@mui/material";
import { useContext, useState, useEffect } from "react";
import "./ManagementsContractEnd.scss";
import { useTranslation } from "react-i18next";
import ManagementHeader from "../ManagementsUpdate/ManagementsUpdateHeader/ManagementsUpdateHeader";
import TotalEnergiesContext from "../../core/store/context/TotalEnergiesContext";
import {
  ManagementRequestInfo,
  PostCallCenterRequestBody,
  RequestStateDescriptionData,
} from "../../core/models/managements/managements.model";
import ButtonElement from "../UI/ButtonElement/ButtonElement";
import { OwnerDataCups } from "../../core/models/ownerData/ownerData.model";
import {
  postCallCenter as postCallCenterFetch,
  postImportDocument,
} from "../../core/services/managements/managements.service";
import ConsumptionsManagementsDeliveryAddressComponent from "../ConsumptionsManagementsDeliveryAddressComponent/ConsumptionsManagementsDeliveryAddressComponent";
import { initialOwnerDataCup } from "../../utils/ownerData/ownerData.util";
import ManagementsRequestState from "../Managements/ManagementsRequestState/ManagementsRequestState";
import ManagementUploadFile from "../Managements/ManagementsUploadFile/ManagementsUploadFile";
import {
  getManagementsRequestTypeData,
  getRegisterTypeId,
  initialManagementRequestInfo,
} from "../../utils/components/managements/managements.util";
import {
  MANAGEMENTS_REGISTER_TYPE_REQUEST,
  MANAGEMENTS_STATE_ERROR,
  MANAGEMENTS_STATE_PENDING,
  MANAGEMENTS_SUBTYPE_CONTRACT_END_GAS,
  MANAGEMENTS_SUBTYPE_CONTRACT_END_LIGHT,
  MANAGEMENTS_SUBTYPE_CONTRACT_END_TEXT,
} from "../../core/constants/constants";
import { formatDate } from "../../utils/dateUtils/formatDate.util";
import ManagementsCancelProcess from "../Managements/ManagementsCancelProcess/ManagementsCancelProcess";
import { getRecipientId } from "../../utils/components/services/services.util";

const ManagementsContractEnd = () => {
  const { t } = useTranslation();
  const { ownerData, userData } = useContext(TotalEnergiesContext);
  const [selectedDeliveryAddress, setSelectedDeliveryAddress] =
    useState<OwnerDataCups>(initialOwnerDataCup);
  const [managementRequestInfo, setManagementRequestInfo] =
    useState<ManagementRequestInfo>(initialManagementRequestInfo);
  const [step, setStep] = useState<number>(0);
  const [isClaimLoading, setIsClaimLoading] = useState<boolean>(false);
  const [requestState, setRequestState] = useState<string>("");
  const [requestStateData, setRequestStateData] =
    useState<RequestStateDescriptionData>({
      title: "",
      description: "",
      descriptionExtra: "",
    });
  const [file, setFile] = useState<File | null>(null);
  const [contractEndDetail, setcontractEndDetail] = useState("");
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);

  useEffect(() => {
    const isFileSelected = file !== null;
    const isAddressSelected = selectedDeliveryAddress.idCups;

    const checkIsButtonDisabled = !(isFileSelected && isAddressSelected);
    setIsButtonDisabled(checkIsButtonDisabled);
  }, [selectedDeliveryAddress, file]);

  const handleSendContractEnd = () => {
    if (ownerData && userData) {
      postCallCenter(contractEndDetail, selectedDeliveryAddress);
    }
  };

  const postCallCenter = (
    incidenceText: string,
    ownerDataCupSelected: OwnerDataCups
  ): void => {
    const { contractCode, envirorment, idContract } = ownerDataCupSelected;

    let subtypeNumber = 0;
    switch (envirorment) {
      case "Luz":
        subtypeNumber = MANAGEMENTS_SUBTYPE_CONTRACT_END_LIGHT;
        break;
      case "Gas":
        subtypeNumber = MANAGEMENTS_SUBTYPE_CONTRACT_END_GAS;
        break;
      default:
        subtypeNumber = 0;
    }

    const managementMessage = `El usuario solicita el cierre de contrato.${
      incidenceText ? ` Detalle de la petición: ${incidenceText}` : ""
    }`;

    if (userData) {

      const IdTipoRegistro = getRegisterTypeId(
        envirorment,
        MANAGEMENTS_REGISTER_TYPE_REQUEST
      )

      const requestBody: PostCallCenterRequestBody = {
        TextoIncidencia: managementMessage,
        CodigosContratos: [+contractCode],
        IdsContratos: [+idContract],
        IdTipoRegistro,
        IdSubTipoReclamacion: subtypeNumber,
        idUsuarioDestino: getRecipientId(IdTipoRegistro, subtypeNumber),
      };
      setIsClaimLoading(true);
      setStep(1);

      postCallCenterFetch(requestBody, userData.token)
        .then(([{ IdCallCenter, IdCarpetaIncidencias }]) => ({
          IdCallCenter,
          IdCarpetaIncidencias,
        }))
        .then(async ({ IdCallCenter, IdCarpetaIncidencias }) => {
          if (IdCallCenter === 0) {
            throw new Error("One or more IdCallCenter values are 0");
          }

          file &&
            (await postImportDocument(
              IdCallCenter,
              IdCarpetaIncidencias,
              file,
              userData.token
            ));
          setRequestState(MANAGEMENTS_STATE_PENDING);
          setRequestStateData(
            getManagementsRequestTypeData(
              MANAGEMENTS_SUBTYPE_CONTRACT_END_TEXT,
              MANAGEMENTS_STATE_PENDING
            )
          );
          setManagementRequestInfo({
            registrarionDate: formatDate(new Date()),
            refferenceNumber: IdCallCenter.toString(),
          });
          setIsClaimLoading(false);
        })
        .catch((error) => {
          setRequestState(MANAGEMENTS_STATE_ERROR);
          setRequestStateData(
            getManagementsRequestTypeData(
              MANAGEMENTS_SUBTYPE_CONTRACT_END_TEXT,
              MANAGEMENTS_STATE_ERROR
            )
          );
          setIsClaimLoading(false);
        });
    }
  };

  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <Box
      component="section"
      className="last-managements"
      paddingBottom={{ md: "5rem" }}
    >
      <ManagementHeader
        title={"Baja por cese"}
        step={step}
        showStepper={true}
      />

      {step === 0 && (
        <Grid container justifyContent="center">
          <Grid item md={8} lg={7} flex={1}>
            <Stack
              bgcolor={{ md: "#fff" }}
              borderRadius="12px"
              boxShadow={{ md: "0px 3px 5px 0px rgba(55, 70, 73, 0.20)" }}
              padding="3rem"
              marginY="2.5rem"
              gap="2rem"
            >
              <Stack width={{ xs: "100%", md: "50%" }}>
                <ConsumptionsManagementsDeliveryAddressComponent
                  ownerDataCups={ownerData?.cups || []}
                  ownerDataCupSelected={selectedDeliveryAddress}
                  setOwnerDataCupSelected={(
                    ownerDataCupSelected: OwnerDataCups
                  ) => setSelectedDeliveryAddress(ownerDataCupSelected)}
                />
              </Stack>
              <FormControl
                sx={{
                  display: "flex",
                  gap: "1rem",
                }}
              >
                <FormLabel htmlFor="claim-detail">
                  <Typography fontWeight={600}>
                    {t("Gestiones.Detalle su petición")}
                    <Typography variant="body2" component="span">
                      {" "}
                      - {t("Opcional")}
                    </Typography>
                  </Typography>
                </FormLabel>
                <TextField
                  className="claim-textfield"
                  value={contractEndDetail}
                  onChange={(e) => setcontractEndDetail(e.target.value)}
                  multiline
                  rows={7}
                />
              </FormControl>

              <ManagementUploadFile
                title={t("Gestiones.Anexo baja por cese de actividad")}
                isRequired={true}
                downloadButtonText={t("Gestiones.Descarga anexo cese")}
                downloadDocumentType="03"
                inputFileInstructions={false}
                onFileUpload={(id, file) => {
                  setFile(file);
                }}
                onFileRemove={(id) => {
                  setFile(null);
                }}
              />

              <FormControl
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  justifyContent: "space-between",
                  gap: "1rem",
                  marginY: "1.5rem",
                }}
              >
                <ButtonElement
                  onClick={() => handleSendContractEnd()}
                  disabled={isButtonDisabled}
                >
                  {t("Gestiones.Solicitar baja")}
                </ButtonElement>
                <ButtonElement type="button" secondary onClick={openModal}>
                  {t("Cancelar")}
                </ButtonElement>
              </FormControl>
            </Stack>
            <ManagementsCancelProcess
              open={isModalOpen}
              handleClose={closeModal}
            />
          </Grid>
        </Grid>
      )}
      {[1, 2, 3].includes(step) && (
        <ManagementsRequestState
          state={requestState}
          isLoading={isClaimLoading}
          managementRequestInfo={managementRequestInfo}
          showManagementRequestInfo
          title={requestStateData.title}
          description={requestStateData.description}
          descriptionExtra={requestStateData.descriptionExtra}
        />
      )}
    </Box>
  );
};

export default ManagementsContractEnd;
